import { render, staticRenderFns } from "./ClinicD.vue?vue&type=template&id=139b51c9&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./ClinicD.vue?vue&type=script&lang=js"
export * from "./ClinicD.vue?vue&type=script&lang=js"
import style0 from "./ClinicD.vue?vue&type=style&index=0&id=139b51c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139b51c9",
  null
  
)

export default component.exports